require('./fullScreenConfirmDialog.scss');
const controller = require('./fullScreenConfirmDialogCtrl').default;
const template = require('./fullScreenConfirmDialog.html');

const deps = [];

module.exports = angular
  .module('bench.ui.fullScreenConfirmDialog', deps)
  .component('blFullScreenConfirmDialog', {
    bindings: {
      icon: '@',
      title: '@',
      message: '@',
      actionLabel: '@',
      dialogRef: '<',
    },
    template,
    controller,
    controllerAs: 'vm',
  });
